import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { useTranslation } from "next-i18next";

export default function ConformationDialog(
	props: Readonly<{
		openPopup: boolean;
		setOpenDeleteConformation: (value: boolean) => void;
		handleYes: () => void;
		text: string;
		className?: string;
	}>,
) {
	const { t } = useTranslation();

	const handleClose = () => {
		props.setOpenDeleteConformation(false);
	};

	return (
		<Dialog
			open={props.openPopup}
			data-testid="confirmation-dialog"
			aria-describedby="alert-dialog-description">
			<DialogContent>
				<DialogContentText id="alert-dialog-description">{props.text}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button data-testid="yes-button" onClick={props.handleYes}>
					{t("yes")}
				</Button>
				<Button data-testid="no-button" onClick={handleClose} autoFocus>
					{t("no")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
